var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsActionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000104677222361103284630000016280980024224308920_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Copy"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 56.7,
    y1: 18.4,
    x2: 56.7,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 51.6,
    y1: 18.4,
    x2: 51.6,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 61.8,
    y1: 18.4,
    x2: 61.8,
    y2: 18.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,17.1c0-5.1,2.6-8.9,5.2-8.9s5.1,3.8,5.1,8.9v25.6c0,0.7-0.6,1.3-1.3,1.3c0,0,0,0,0,0h-7.7 c-0.7,0-1.3-0.6-1.3-1.3c0,0,0,0,0,0V17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,26.1c0,5.1-10.2,7.7-10.2,14.1v1.3h10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.1,26.1c0,5.1,10.2,7.7,10.2,14.1v1.3H26.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.9,
    y1: 32.4,
    x2: 20.9,
    y2: 43.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22.2,
    y1: 15.8,
    x2: 19.7,
    y2: 15.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 18.4,
    y1: 49.1,
    x2: 18.4,
    y2: 56.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.4,52.9c-0.9,0-1.8,0.5-2.2,1.3c-1.4-1.6-3.8-1.8-5.4-0.4c-0.9,0.7-1.3,1.8-1.3,2.9 c-2.8,0-3.8,2.3-3.8,5.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.5,
    y1: 49.1,
    x2: 23.5,
    y2: 56.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.5,52.9c0.9,0,1.8,0.5,2.2,1.3c1.4-1.6,3.8-1.8,5.4-0.4c0.9,0.7,1.3,1.8,1.3,2.9c2.8,0,3.8,2.3,3.8,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.5,13.3h38.9c2.8,0,5.1,2.3,5.1,5.1c0,0,0,0,0,0v38.3c0,2.8-2.3,5.1-5.1,5.1l0,0H5.6 c-2.8,0-5.1-2.3-5.1-5.1V18.4c0-2.8,2.3-5.1,5.1-5.1h10.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.4,
    y: 28.6,
    className: "st1",
    width: 20.4,
    height: 15.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 61.8,
    y1: 49.1,
    x2: 41.4,
    y2: 49.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 61.8,
    y1: 54.2,
    x2: 41.4,
    y2: 54.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.5,
    y1: 23.5,
    x2: 26.1,
    y2: 23.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 15.8,
    y1: 23.5,
    x2: 0.5,
    y2: 23.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsActionIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-ActionIcon.08160322dd5754ccdef5dda9e51993f9.svg";
export { ForwardRef as ReactComponent };